/*@ngInject*/
const UIResponsiveViewportDirective = function ($window, $rootScope) {

    let linkFunction = function ($scope) {

        let window = $($window);

        function onResize() {
            // let screenWidth = window.width();

            // if (screenWidth > 1200) {
            //     $rootScope.isExtraSmallScreen = false;
            //     $rootScope.isSmallScreen = false;
            //     $rootScope.isMediumScreen = false;
            //     $rootScope.isLargeScreen = true;
            // }
            // else if (screenWidth > 992) {
            //     $rootScope.isExtraSmallScreen = false;
            //     $rootScope.isSmallScreen = false;
            //     $rootScope.isMediumScreen = true;
            //     $rootScope.isLargeScreen = false;
            // }
            // else if (screenWidth > 768) {
            //     $rootScope.isExtraSmallScreen = false;
            //     $rootScope.isSmallScreen = true;
            //     $rootScope.isMediumScreen = false;
            //     $rootScope.isLargeScreen = false;
            // }
            // else {
            //     $rootScope.isExtraSmallScreen = true;
            //     $rootScope.isSmallScreen = false;
            //     $rootScope.isMediumScreen = false;
            //     $rootScope.isLargeScreen = false;
            // }

            $rootScope.isLargeScreen = true;
        }

        $scope.$on('$destroy', function () {
            window.off('resize.uiResponsiveViewport', onResize);
        });

        window.on('resize.uiResponsiveViewport', onResize);
        onResize();
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiResponsiveViewport', UIResponsiveViewportDirective);
